export default __webpack_public_path__ + "static/ssocase2-e1fa12e93788db51889d4369b61458ee.png";